import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './../AuthContext';

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

const CareerProgress = () => {
    const { userData, liveUserData, login } = useAuth();
    const [showCoursePopup, setShowCoursePopup] = useState(false);
    const [showInternshipPopup, setShowInternshipPopup] = useState(false);
    const [showCoachPopup, setShowCoachPopup] = useState(false);
    const [showExpertsPopup, setShowExpertsPopup] = useState(false);
    const [isMeetingAttended, setIsMeetingAttended] = useState(false);
    const [isExpertMeetingAttended, setIsExpertMeetingAttended] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();


    useEffect(() => {
        const loadMeetingStatus = async () => {
            try {
                const meetingResponse = await axios.post(`${BASE_URL}/getMeetingAttended.php`, {
                    userId: userData.userId
                });

                // Update states first before using them in conditions
                const isMeeting = meetingResponse.data[0].isMeetingAttended == 1;
                const isExpertMeeting = meetingResponse.data[0].isExpertMeetingAttended == 1;

                setIsMeetingAttended(isMeeting);
                setIsExpertMeetingAttended(isExpertMeeting);

                if (liveUserData?.recommendedCareer && liveUserData.recommendedCareerTime &&
                    !(liveUserData?.courseTaken || liveUserData?.InternshipTaken || liveUserData?.spfFinished)) {
                    const currentTime = Date.now();
                    const timeElapsed = currentTime - liveUserData.recommendedCareerTime;
                    if (timeElapsed > 604800000) {
                        setShowCoursePopup(true);
                    }
                } else if (liveUserData?.courseTaken && !(liveUserData?.InternshipTaken || liveUserData?.spfFinished)) {
                    const currentTime = Date.now();
                    const timeElapsed = currentTime - liveUserData?.courseTakenTime;
                    if (timeElapsed > 604800000) {
                        setShowInternshipPopup(true);
                    }
                }
            } catch (error) {
                console.error("Error fetching meeting status:", error);
            }
        };

        loadMeetingStatus();
    }, [liveUserData]);

    useEffect(() => {
        console.log(liveUserData);
        console.log(isExpertMeetingAttended)
        if (liveUserData?.courseTaken && liveUserData?.InternshipTaken && isMeetingAttended && !liveUserData?.spfFinished && !isExpertMeetingAttended) {
            setShowCoachPopup(false);
            setShowExpertsPopup(true);
        }
        else if (liveUserData?.InternshipTaken && !liveUserData?.spfFinished && !isMeetingAttended && !isExpertMeetingAttended) {
            setShowExpertsPopup(false);
            setShowCoachPopup(true);
        }else {
            setShowCoachPopup(false);
            setShowExpertsPopup(false);
        }
    }, [isMeetingAttended, isExpertMeetingAttended, liveUserData]);

    const setSPFCompleted = async () => {
        await axios.post(`${BASE_URL}/saveProgress.php`, {
            userId: liveUserData.userId,
            spfFinished: 1,
        });

        // Update liveUserData and login
        const updatedUserData = { ...liveUserData, spfFinished: true };
        login(updatedUserData);
    }

    const handleYesCourse = async () => {
        try {
            await axios.post(`${BASE_URL}/saveProgress.php`, {
                categories: liveUserData?.recommendedCareer,
                recommendedTime: liveUserData?.recommendedCareerTime,
                userId: liveUserData?.userId,
                courseTaken: 1,
                courseTakenTime: Date.now(),
            });

            // Update liveUserData and login
            const updatedUserData = {
                ...liveUserData,
                courseTakenTime: Date.now(), courseTaken: true
            };
            login(updatedUserData);

            setShowCoursePopup(false);
        } catch (error) {
            console.error('Error saving course progress:', error);
        }
    };

    const handleNeedTimeCourse = async () => {
        try {
            await axios.post(`${BASE_URL}/saveProgress.php`, {
                categories: liveUserData?.recommendedCareer,
                recommendedTime: Date.now(),
                userId: liveUserData?.userId,
            });

            // Update liveUserData and login
            const updatedUserData = { ...liveUserData, recommendedCareerTime: Date.now() };
            login(updatedUserData);

            setShowCoursePopup(false);
        } catch (error) {
            console.error('Error saving course progress:', error);
        }
    };

    const handleYesInternship = async () => {
        try {
            // Google search logic: open in a new window
            // window.open(`https://www.google.com/search?q=Internship+on+${liveUserData.recommendedCareer}`, '_blank');

            // Update InternshipTaken in database
            await axios.post(`${BASE_URL}/saveProgress.php`, {
                categories: liveUserData?.recommendedCareer,
                recommendedTime: liveUserData?.recommendedCareerTime,
                userId: liveUserData?.userId,
                courseTaken: 1,
                courseTakenTime: liveUserData?.courseTakenTime,
                InternshipTakenTime: Date.now(),
                InternshipTaken: 1,
            });

            // Update liveUserData and login
            const updatedUserData = { ...liveUserData, InternshipTaken: true, InternshipTakenTime: Date.now() };
            login(updatedUserData);

            setShowInternshipPopup(false);
        } catch (error) {
            console.error('Error saving internship progress:', error);
        }
    };

    const handleNeedTimeInternship = async () => {
        try {
            // Google search logic: open in a new window
            // window.open(`https://www.google.com/search?q=Internship+on+${liveUserData.recommendedCareer}`, '_blank');

            // Update InternshipTaken in database
            await axios.post(`${BASE_URL}/saveProgress.php`, {
                categories: liveUserData?.recommendedCareer,
                recommendedTime: Date.now(),
                userId: liveUserData?.userId,
                courseTaken: 1,
                courseTakenTime: Date.now(),
            });

            // Update liveUserData and login
            const updatedUserData = { ...liveUserData, courseTakenTime: Date.now() };
            login(updatedUserData);

            setShowInternshipPopup(false);
        } catch (error) {
            console.error('Error saving internship progress:', error);
        }
    };

    const handleNoCourse = () => {
        setShowCoursePopup(false);
        setShowExpertsPopup(true);
    };

    const searchCoursesInTabs = (recommendedCareer) => {
        if (!recommendedCareer) return;
    
        const careers = recommendedCareer.split(',').map(career => career.trim());
    
        careers.forEach((career, index) => {
            setTimeout(() => {
                const searchUrl = `https://www.google.com/search?q=${encodeURIComponent(career + " Course")}`;
                window.open(searchUrl, '_blank');
            }, index * 500); // Delay each tab by 500ms
        });
    };        
    
    const handleNoInternship = () => {
        setShowInternshipPopup(false);
        setShowExpertsPopup(true);
    };

    const handleExpertsContinue = async () => {
        try {
            // Save SPF Finished status
            await axios.post(`${BASE_URL}/saveProgress.php`, {
                userId: liveUserData?.userId,
                courseTaken: 1,
                InternshipTaken: 1,
                InternshipTakenTime: liveUserData?.InternshipTakenTime ? liveUserData?.InternshipTakenTime : 0,
                spfFinished: 1,
            });

            // Update liveUserData and login
            const updatedUserData = { ...liveUserData, spfFinished: true };
            login(updatedUserData);

            // Navigate to meet experts page
            window.location.href = '/meet-experts';
        } catch (error) {
            console.error('Error saving SPF finished:', error);
        }
    };

    if (isLoading) return <div>Loading...</div>;

    return (
        <div>
            {showCoursePopup && !liveUserData?.courseTaken && (

                <div className="career-progress-container">
                    <div className="career-progress-popup">
                        <button onClick={() => setShowCoursePopup(false)} className="quiz-close-button">
                            &times;
                        </button>
                        <h3>Take the Next Step in Your Career Journey</h3>
                        <p>
                            Based on your interest in <strong>{liveUserData?.recommendedCareer}</strong>, here are some suggestions to help
                            you succeed in this field. The first step could be gaining foundational knowledge through courses.
                        </p>
                        <ul>
                            <li>📘 <strong>Courses:</strong> Enroll in a course on {liveUserData?.recommendedCareer} to build a strong foundation.</li>
                            <li>💡 <strong>Internships:</strong> Apply your knowledge with hands-on experience in the industry.</li>
                            <li>🎓 <strong>Mentorship:</strong> Connect with experts to get guidance on advanced topics and career advice.</li>
                        </ul>
                        <div className="career-roadmap">
                            <h4>📍 Your Career Roadmap</h4>
                            <div className="roadmap-steps">
                                <span className="step completed">Career Test ✅</span>
                                <span className="arrow">→</span>
                                <span className="step">Courses</span>
                                <span className="arrow">→</span>
                                <span className="step">Internship</span>
                                <span className="arrow">→</span>
                                <span className="meet-step">Coach</span>
                                <span className="arrow">→</span>
                                <span className="meet-step">Expert</span>
                            </div>
                        </div>
                        <div className="action-buttons">
                            <button onClick={handleYesCourse} className="yes-button">Yes, I’ve taken a course</button>
                            <button onClick={handleNeedTimeCourse} className="need-time-button">I need more time</button>
                            <button onClick={() => {searchCoursesInTabs(liveUserData?.recommendedCareer)}} className="no-button">No, show me resources</button>
                        </div>
                        <div className="career-progress-extra-resources">
                            <h4>Recommended Resources:</h4>
                            <ul>
                                {liveUserData?.recommendedCareer.split(',').map((career, index) => (
                                    <li key={index}>
                                        <a
                                            href={`https://www.google.com/search?q=${encodeURIComponent(career.trim())}+Course`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Browse Courses on {career.trim()} &rarr;
                                        </a>
                                    </li>
                                ))}
                                <li>
                                    <a href="https://www.coursera.org/" target="_blank" rel="noopener noreferrer">
                                        Explore Courses on Coursera &rarr;
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/learning/" target="_blank" rel="noopener noreferrer">
                                        Professional Learning on LinkedIn &rarr;
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <p>You can track you progress in your <a href='/profile'>profile</a> anytime</p>
                    </div>
                </div>
            )}

            {showInternshipPopup && !liveUserData?.InternshipTaken && (
                <div className="career-progress-container">
                    <div className="career-progress-popup">
                        <button onClick={() => setShowInternshipPopup(false)} className="quiz-close-button">
                            &times;
                        </button>
                        <h3>Take Your Career to the Next Level with an Internship</h3>
                        <p>
                            An internship in <strong>{liveUserData?.recommendedCareer}</strong> can be an excellent way to gain hands-on experience,
                            build industry connections, and enhance your resume. It’s a crucial step in becoming a professional in this field.
                        </p>
                        <ul>
                            <li>👨‍💼 <strong>Industry Exposure:</strong> Learn the real-world applications of your skills.</li>
                            <li>💼 <strong>Build Your Network:</strong> Collaborate with professionals and grow your industry contacts.</li>
                            <li>📈 <strong>Enhance Your Profile:</strong> Make your resume stand out with practical experience.</li>
                        </ul>
                        <div className="career-roadmap">
                            <h4>📍 Your Career Roadmap</h4>
                            <div className="roadmap-steps">
                                <span className="step completed">Career Test ✅</span>
                                <span className="arrow">→</span>
                                <span className="step completed">Courses ✅</span>
                                <span className="arrow">→</span>
                                <span className="step">Internship</span>
                                <span className="arrow">→</span>
                                <span className="meet-step">Coach</span>
                                <span className="arrow">→</span>
                                <span className="meet-step">Expert</span>
                            </div>
                        </div>
                        <div className="action-buttons">
                            <button onClick={handleYesInternship} className="yes-button">
                                Yes, I've taken an internship
                            </button>
                            <button onClick={handleNeedTimeInternship} className="need-time-button">I need more time</button>
                            <button onClick={handleYesInternship} className="no-button">
                                No, I need help
                            </button>
                        </div>
                        <div className="career-progress-extra-resources">
                            <h4>How to Find the Right Internship:</h4>
                            <ul>
                                {liveUserData?.recommendedCareer.split(',').map((career, index) => (
                                    <li key={index}>
                                        <a
                                            href={`https://www.google.com/search?q=${encodeURIComponent(career.trim())}+Internship`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Search for Internships in {career.trim()} &rarr;
                                        </a>
                                    </li>
                                ))}
                                <li>
                                    <a href="https://internshala.com/" target="_blank" rel="noopener noreferrer">
                                        Explore Opportunities on Internshala &rarr;
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/jobs/" target="_blank" rel="noopener noreferrer">
                                        Browse Internships on LinkedIn Jobs &rarr;
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <p>You can track you progress in your <a href='/profile'>profile</a> anytime</p>
                    </div>
                </div>
            )
            }
            {/* && !(liveUserData?.courseTaken && liveUserData?.InternshipTaken)  */}
            {showCoachPopup && (
                <div className="career-progress-container">
                    <div className="career-progress-popup">
                        <button onClick={() => setShowCoachPopup(false)} className="quiz-close-button">
                            &times;
                        </button>
                        <h3>How is Your Career Exploration Journey Going?</h3>
                        <p>
                            It’s great that you’re exploring <strong>{liveUserData?.recommendedCareer}</strong>! But how do you feel about your current journey? Have you been able to align your passion with your career path, or are you feeling a bit uncertain?
                        </p>
                        <ul>
                            <li>📚 <strong>Courses:</strong> Have the courses you've taken helped clarify your goals? Do you feel equipped with the knowledge to move forward?</li>
                            <li>💼 <strong>Internships:</strong> If you’ve done an internship, how was your experience? Were you able to apply what you learned?</li>
                        </ul>
                        <div className="career-roadmap">
                            <h4>📍 Your Career Roadmap</h4>
                            <div className="roadmap-steps">
                                <span className="step completed">Career Test ✅</span>
                                <span className="arrow">→</span>
                                <span className="step completed">Courses ✅</span>
                                <span className="arrow">→</span>
                                <span className="step completed">Internship ✅</span>
                                <span className="arrow">→</span>
                                <span className="step">Coach</span>
                                <span className="arrow">→</span>
                                <span className="step">Expert</span>
                            </div>
                        </div>
                        <p>
                            If you’re feeling unsure about your direction, a <b>career coach</b> can help you assess your progress and refine your goals. They can provide strategies and clarity to move forward confidently.
                        </p>
                        <div className="action-buttons">
                            <button onClick={() => navigate("/career-coaches")} className="yes-button">
                                Yes, I’d like to connect with a coach
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showExpertsPopup && (
                <div className="career-progress-container">
                    <div className="career-progress-popup">
                        <button onClick={() => setShowExpertsPopup(false)} className="quiz-close-button">
                            &times;
                        </button>
                        <h3>Ready to Connect with Industry Experts?</h3>
                        <p>
                            You’ve already made great progress in <strong>{liveUserData?.recommendedCareer}</strong>! Now, connecting with professionals in your industry can help you gain insights and better understand the real-world demands of your career path.
                        </p>
                        <ul>
                            <li>🔬 <strong>Research:</strong> Are you gaining practical knowledge in your field?</li>
                            <li>💡 <strong>Insights:</strong> Do you understand the career landscape and the best opportunities available?</li>
                        </ul>
                        <div className="career-roadmap">
                            <h4>📍 Your Career Roadmap</h4>
                            <div className="roadmap-steps">
                                <span className="step completed">Career Test ✅</span>
                                <span className="arrow">→</span>
                                <span className="step completed">Courses ✅</span>
                                <span className="arrow">→</span>
                                <span className="step completed">Internship ✅</span>
                                <span className="arrow">→</span>
                                <span className="step completed">Coach ✅</span>
                                <span className="arrow">→</span>
                                <span className="step">Expert</span>
                            </div>
                        </div>
                        <p>
                            Industry experts can offer practical advice, mentorship, and networking opportunities to help you succeed in your chosen field.
                        </p>
                        <div className="action-buttons">
                            <button onClick={() => navigate("/professionals")} className="yes-button">
                                Yes, I’d like to connect with experts
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div >
    );
};

export default CareerProgress;
